'use client';

import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';

import { EXPO } from '../about/reveal';

function useFloat(active: boolean) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !active) return;
    let frame = 0;
    const start = performance.now();
    const tick = (now: number) => {
      const t = (now - start) / 1000;
      el.style.translate = `${(Math.cos(t * 0.5 + 0.9) * 4).toFixed(2)}px ${(Math.sin(t * 0.77 + 0.9) * 6).toFixed(2)}px`;
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(frame);
      el.style.translate = '';
    };
  }, [active]);
  return ref;
}

export default function FinalSticker({
  text,
  play,
  reduce,
  className,
}: {
  text: string;
  play: boolean;
  reduce: boolean | null;
  className?: string;
}) {
  const [landed, setLanded] = useState(false);
  const floatRef = useFloat(landed && !reduce);
  const drawn = play || !!reduce;

  return (
    <div
      ref={floatRef}
      className={className}>
      <svg
        viewBox="0 0 50.27 51.5"
        fill="none"
        aria-hidden
        className="hidden lg:block absolute overflow-visible left-[9.65625rem] top-[-6.96875rem] w-[6.28375rem] h-[6.4375rem]">
        <path
          d="M0.75 50.75C1.24 44.75 4.25 40.12 8.47 36.19C12.69 32.25 18.12 29 23.5 25.75C28.87 22.5 34.19 19.25 38.16 15.31C42.13 11.37 44.75 6.75 44.75 0.75"
          stroke="#111715"
          strokeOpacity={0.6}
          strokeWidth={1.5}
          strokeLinecap="round"
          pathLength={1}
          strokeDasharray={1}
          style={{
            strokeDashoffset: drawn ? 0 : 1,
            transition: reduce ? 'none' : 'stroke-dashoffset 1.1s cubic-bezier(.65,0,.35,1) .35s',
          }}
        />
        <path
          d="M39.98 5.52L44.75 0.75L49.52 5.52"
          stroke="#111715"
          strokeOpacity={0.6}
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ opacity: drawn ? 1 : 0, transition: reduce ? 'none' : 'opacity .25s ease 1.35s' }}
        />
      </svg>
      <motion.p
        initial={reduce ? false : { opacity: 0, y: 10, scale: 0.94 }}
        animate={play ? { opacity: 1, y: 0, scale: 1 } : undefined}
        transition={{ opacity: { duration: 0.5, ease: EXPO }, default: { duration: 0.7, ease: EXPO } }}
        onAnimationComplete={() => setLanded(true)}
        className="m-0 whitespace-nowrap rounded-[0.5rem] bg-[#FFE11A] font-geist font-[500] text-black px-[1.5rem] py-[0.75rem] text-[2.25rem] leading-[3rem] lg:px-[1.75rem] lg:text-[2rem]">
        {text}
      </motion.p>
    </div>
  );
}
